import React from 'react';
import cn from 'classnames';
import { t, getVatPriceProps } from '@insight/toolkit-utils';
import Currency from '../Currency/Currency';
import PartNumbers from '../PartNumbers/PartNumbers';
import FallbackImage from '../Image/FallbackImage';
import Icon from '../Icon/Icon';
import { PDPImage } from '../PDPTabs';

export const AddToCartModalResource = ({
  categoryType,
  currencyCode,
  imageUrl,
  imageDescription,
  shortDescription,
  insightPart,
  mfrPart,
  quantity,
  stock,
  price,
  priceInclVat,
  hideImage,
  showDividers,
  showQuantityExceed,
  isWarranty,
  isCarrier,
  showPrice,
  showVAT,
  asyncItem,
  isCCXProduct
}) => {
  const { exclVatProps, inclVatProps } = getVatPriceProps(showVAT);

  const renderPrice = () => {
    if (!showVAT) {
      return (
        <Currency currencyCode={currencyCode} value={price} {...exclVatProps} />
      );
    }

    return (
      <div className="c-add-item-to-cart__product__price__vat-wrapper">
        <Currency currencyCode={currencyCode} value={price} {...exclVatProps} />
        <div className="c-add-item-to-cart__inc-vat-wrapper">
          <Currency
            value={priceInclVat}
            currencyCode={currencyCode}
            {...inclVatProps}
          />
        </div>
      </div>
    );
  };

  return (
    <div
      className={cn(
        'c-add-item-to-cart__resource o-grid o-grid--gutters-small',
        {
          'c-add-item-to-cart__resource--dividers': showDividers,
        }
      )}
    >
      <div className="c-add-item-to-cart__image o-grid__item u-1/1 u-1/6@desktop">
        {!hideImage ? (
          <PDPImage src={imageUrl} alt={imageDescription} />
        ) : (
          <FallbackImage
            src={imageUrl}
            alt={imageDescription || 'Product description'}
          />
        )}
      </div>
      <div className="o-grid__item u-1/1 u-5/6@desktop">
        <div className="c-add-item-to-cart__product">
          {isWarranty || categoryType ? (
            <div className="c-add-item-to-cart__product__category-type">
              {categoryType
                ? categoryType.replace(/-/g, ' ')
                : 'Protection Plan'}
            </div>
          ) : null}
          {isCarrier && (
            <div className="c-add-item-to-cart__product__category-type">
              {t('Carrier provider')}
            </div>
          )}
          <div
            className={cn(
              'c-add-item-to-cart__product__name',
              { 'is-warranty': isWarranty || categoryType },
              { 'is-carrier': isCarrier }
            )}
          >
            {t(shortDescription)}
          </div>
          <div>
            <PartNumbers insightPart={insightPart} mfrPart={mfrPart} inline />
          </div>
          <div className="o-grid">
            <div className="c-add-item-to-cart__product__key-value o-grid__item u-3/6 u-4/6@desktop">
              <span>
                {t('Quantity')}: {quantity}
              </span>
              {quantity > stock && showQuantityExceed && (
                <div className="c-add-item-to-cart__product__error">
                  <Icon icon="alert" type="error" />
                  <span className="c-add-item-to-cart__product__error-msg">
                    {t(
                      'Your quantity exceeds our current stock. Please review the available quantity in cart.'
                    )}
                  </span>
                </div>
              )}
            </div>
            {showPrice && (
              <div
                className={cn(
                  'c-add-item-to-cart__product__price o-grid__item u-3/6 u-2/6@desktop',
                  { 'o-grid o-grid--justify-right': showVAT }
                )}
              >
                {asyncItem && (
                  <span>
                    {asyncItem?.abbreviation || asyncItem?.contractName}
                  </span>
                )}
                {isCCXProduct && (
                  <div className="c-add-item-to-cart__accessory__proration">{t('Proration applied')}</div>
                )}
                <span>
                  {t('Your price')}
                  :&nbsp;
                </span>
                {renderPrice()}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddToCartModalResource;
